// for the view to monitor when it's time to close
Pegasus.LaunchPlatformController = Em.Controller.extend({
  currentUserSkinName: null,
  isNativeHost: false,
  isDeluxeHost: false,
  isDoneLaunching: false
});

Pegasus.LaunchPlatformController.reopen({
  isEditorComplete: false,
  isRetrieveComplete: true
});

Pegasus.LaunchPlatformController.reopen({
  inventory: {
    Theme: {
      didRetrieve: false
    },
    Block: {
      didRetrieve: false
    }
  }
});

